import styled from '@venue/common/styled';

export const Loader = styled.div``;
